import axios from 'axios'
import router from "./routes.config.js";
// axios 配置
// axios.defaults.timeout = 50000;
// axios.defaults.headers.post['contentType'] = "application/json"
// axios.defaults.baseURL = 'http://192.168.206.33:7008/ent/dict/v2';
// axios.defaults.baseURL = 'http://10.20.20.118:7008/ent/dict/v2';
// 拦截器
axios.interceptors.request.use(
  config => {
    if(window.localStorage.getItem('token')){
      config.headers= {
        'X-Token':window.localStorage.getItem('token'),
        'X-UserId':window.localStorage.getItem('userId'),
        'Content-Type':"application/json"
      }
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
// code状态码200判断
axios.interceptors.response.use((res) => {
  // console.log("haha"+res.data.code)
  var code = res.data.code || res.data.CODE;
  if(code === 401){
    // alert("登录时间过长，请重新登录")
    router.push('/')
    return Promise.reject(res);
  }else if(code === 420){
    console.log('节点过多无法显示！');
    return Promise.reject(res);
  }else if(code === 403){
    // alert('您未开通此权限，请联系管理员')
    // router.push('/ModuleCate')
    return Promise.reject(res);
  }
  return res;
}, (error) => {
  console.log('promise error:' + error);
  return Promise.reject(error);
});
export default axios;



// WEBPACK FOOTER //
// ./src/http.js